module.exports = __webpack_public_path__ + "static/media/Joltik_gaussian2.01b72d59.png";